import { Component, Inject } from '@angular/core';
import { GenericAuthService, GENERIC_AUTH_SERVICE_TOKEN } from '@nk/auth-lib';

@Component({
  selector: 'nk-callback-cors-auth',
  templateUrl: './callback-cors-auth.component.html',
  standalone: false,
})
export class CallbackCorsAuthComponent {
  constructor(@Inject(GENERIC_AUTH_SERVICE_TOKEN) private _authService: GenericAuthService) {
    this._authService.crossOriginVerification();
  }
}
